module.exports = __webpack_public_path__ + "img/broadleaved.81f33e82.svg";